export default "__VITE_ASSET__BonbNtTO__"